/**
 * @Description 标签(从原本的Top组件迁移过来的)
 */

import { FC, useEffect, useMemo, useRef, useState } from 'react';
import { isArray, isNotEmpty } from '@lhb/func';
import { getLabelRelations } from '@/common/api/networkplan';
// import { typeLabelImgMap } from '@/views/iterate/pages/siteselectionmap/ts-config';
import { typeLabelImgMap } from '@/common/enums/business/siteselectionmap';
import styles from './index.module.less';
import cs from 'classnames';
import IconFont from '@/common/components/IconFont';

const LabelRow: FC<any> = ({
  clusterId,
  detail,
  overviewData,
}) => {
  const labelRef = useRef<any>(null);// 标签ref

  const [isFold, setIsFold] = useState<boolean>(true); // 标签行是否折叠，折叠情况下只展示一行
  const [typeLabel, setTypeLabel] = useState<string>(''); // 类型标签（A/B/C/D），可能为空
  const [labels, setLabels] = useState<string[]>([]); // 类型标签（A/B/C/D）以外的其他标签，可能为空
  const [showArrowIcon, setShowArrowIcon] = useState<boolean>(false);
  const [isIndustryCompetition, setIsIndustryCompetition] = useState<boolean>(false);

  useEffect(() => {
    if (!clusterId) return;
    if (!overviewData?.id) return;
    getLabels();
  }, [clusterId, overviewData?.id]);

  // 判断是否显示展开收起图标
  useEffect(() => {
    if (!labels?.length) {
      return;
    }
    setShowArrowIcon(labelRef.current?.scrollHeight > labelRef.current?.clientHeight);
  }, [labels]);

  // 是否是商场类型
  const isMall = useMemo(() => {
    const { resourceMallFlag } = detail || {};
    return !!resourceMallFlag;
  }, [detail]);

  /**
   * @description 请求商圈标签
   *
   *  商圈id变动、以及标签编辑后
   */
  const getLabels = () => {
    setTypeLabel('');
    setLabels([]);

    // 当前商圈设定的网规标签、自定义标签
    getLabelRelations({ modelClusterId: clusterId }).then((data) => {
      // 2 网规标签
      const curTypeLabels = data['2'];
      if (isArray(curTypeLabels) && curTypeLabels.length) {
        setTypeLabel(curTypeLabels[0].name);
      }
      // 1 系统标签、3 自定义标签，合并展示
      const curSystemLabels = data['1'];
      const curCustomLabels = data['3'];
      const { childCompanyPlanned, doubleRecommendation, industryCompetition } = overviewData || {};
      setIsIndustryCompetition(industryCompetition);
      setLabels([
        ...(isArray(curSystemLabels) ? curSystemLabels.map(obj => obj.name) : []),
        ...(doubleRecommendation ? ['双向推荐'] : []), // 是否双向推荐
        ...(childCompanyPlanned ? ['已规划'] : []),
        ...(isArray(curCustomLabels) ? curCustomLabels.map(obj => obj.name) : [])
      ]);
    });
  };

  /**
   * @description 类型标签img
   */
  const typeLabelImg = useMemo(() => {
    return typeLabel ? (typeLabelImgMap.get(typeLabel) || '') : '';
  }, [typeLabel]);

  /**
   * @description 点击折叠标签按钮
   * @param e 事件
   */
  const handleFold = (e: any) => {
    // console.log('handleFold e', e);
    setIsFold(!isFold);
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <>
      <div className={cs(styles.labelRow)}>
        <div className={styles.labelRowWrap} >
          {(isArray(labels) && !!labels.length) || isIndustryCompetition ? <div className={cs(styles.labelsWrapper, isFold && styles.isFold,
            isMall ? styles.isMall : ''
          )}
          ref={labelRef}
          >
            {
              isIndustryCompetition ? <div className={styles.imgCon}>
                <img
                  src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/icon_flame@2x.png`}
                  width={12}
                  height={12}
                />
              </div> : <></>
            }
            {labels.filter(lbl => isNotEmpty(lbl)).map((lbl:string, index: number) => <div key={index} className={styles.label}>{lbl}</div>)}
            {typeLabelImg ? <div className={cs(styles.typeIcon, 'mr-8')}>
              <img src={typeLabelImg} width='100%' height='100%' />
            </div> : <></>}
          </div> : <></>}
          <div className={styles.operations}>
            {isArray(labels) && !!labels.length &&
            // 判断在非展开情况下，高度是否会超过可视高度
            showArrowIcon ? <div className={cs(styles.btn, 'mr-8')} onClick={(e) => handleFold(e)}>
                <IconFont
                  iconHref='pc-common-icon-a-iconarrow_down'
                  className={isFold ? styles.arrowIcon : styles.arrowIconUp} style={{ color: '#979797' }}
                />
              </div> : <></>}
          </div>
        </div>
      </div>
    </>
  );
};

export default LabelRow;
